// Stylized NIX18 logo — based on the official Dutch responsible-drinking mark
// (see https://www.nix18.nl). Single-color SVG so it inherits text color.
const Nix18Logo = ({ size = 56, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 120"
    width={size}
    height={size}
    role="img"
    aria-label="NIX18 — geen 18, geen alcohol"
    className={className}
  >
    {/* Outer circle */}
    <circle cx="60" cy="60" r="56" fill="none" stroke="currentColor" strokeWidth="4" />
    {/* Inner circle */}
    <circle cx="60" cy="60" r="46" fill="none" stroke="currentColor" strokeWidth="1.5" />
    {/* "NIX" wordmark */}
    <text
      x="60"
      y="55"
      textAnchor="middle"
      fontFamily="Anton, Impact, sans-serif"
      fontSize="30"
      fontWeight="700"
      fill="currentColor"
      letterSpacing="2"
    >
      NIX
    </text>
    {/* "18" wordmark */}
    <text
      x="60"
      y="92"
      textAnchor="middle"
      fontFamily="Anton, Impact, sans-serif"
      fontSize="36"
      fontWeight="700"
      fill="currentColor"
    >
      18
    </text>
    {/* Bottom curve text */}
    <defs>
      <path id="nix18arc" d="M 18,68 A 42,42 0 0 0 102,68" fill="none" />
    </defs>
    <text fontSize="6" fill="currentColor" letterSpacing="2" fontFamily="monospace">
      <textPath href="#nix18arc" startOffset="50%" textAnchor="middle">
        GEEN 18 — GEEN ALCOHOL
      </textPath>
    </text>
  </svg>
);

export default Nix18Logo;
